export default __webpack_public_path__ + "static/media/diabeat_it_web_portal_background.398f968f.jpeg";